var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.45 6.485a1.007 1.007 0 00-.817-.69l-2.964-.43a.576.576 0 01-.435-.316L8.908 2.363a1.013 1.013 0 00-1.816 0L5.766 5.049a.576.576 0 01-.435.316l-2.964.43a1.007 1.007 0 00-.817.69c-.12.368-.022.764.256 1.035L3.95 9.61a.58.58 0 01.166.513l-.504 2.95a1 1 0 00.4.99 1.01 1.01 0 001.066.078l2.652-1.395a.575.575 0 01.538 0l2.652 1.395a1.003 1.003 0 001.066-.078 1 1 0 00.4-.99l-.504-2.95a.58.58 0 01.166-.513l2.145-2.09c.278-.27.375-.667.256-1.035z",
    fill: "#fff"
  })));
}
export default SvgStar;